import React, {FC, useState, useEffect} from "react";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import InfoContainer from "./InfoContainer";
import './InfoCarousel.css'

interface InfoItem {
    logoDark: string;
    logoWhite: string;
    title: string;
    description: string;
    redirectLink: string;
}

interface InfoCarouselProps {
    infoItems: InfoItem[];
}


const InfoCarousel:FC<InfoCarouselProps> = ({infoItems}) => {
    const [activeIndex, setActiveIndex] = useState(1);
    const sliderRef = React.useRef<Slider>(null);

    const sliderSettings = {
        className: "active",
        centerPadding: '30px',
        slidesToShow: 3,
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToScroll: 1,
        initialSlide:1,
        arrows:false,


        responsive:[
            {
                breakpoint:500,
                settings:{
                    slidesToShow:1,
                    centerMode:true,
                    dots:true,
                    
                }
            },
            {
                breakpoint:600,
                settings:{
                    slidesToShow:1,
                    centerMode:true,
                    arrows:true,
                    
                }
            },
            {
                breakpoint:1000,
                settings:{
                    slidesToShow:2.2,
                    
                }
            }
        ],


        afterChange: (current:number) => {
            setActiveIndex(current)
        },

    };

    useEffect(() => {
        if (sliderRef.current) {
            setActiveIndex(Math.floor((infoItems.length - 1) / 2)); 
        }
    }, [infoItems.length]);


    return(
        <div className="info-section">
            <h1 className="info-section-title">Private Equity Funding Solutions</h1>
            <div className="info-carousel">
                <Slider ref={sliderRef} {...sliderSettings}>
                {infoItems.map((infoItem, index) => (
                    <InfoContainer 
                        key={infoItem.title}
                        logoDark={infoItem.logoDark}
                        logoWhite={infoItem.logoWhite}
                        title={infoItem.title}
                        description={infoItem.description}
                        redirectLink={infoItem.redirectLink}
                        isActive={index === activeIndex}
                    />
                ))}
                </Slider>
            </div>
        </div>
    )
}

export default InfoCarousel;
